import fetchExpected from "./fetchExpected";
import sendExpected from "./sendExpected";
import fetchReal from "./fetchReal";
import sendReal from "./sendReal";
import fetchPhotoReasons from "./fetchPhotoReasons";
import sendSecurityPhoto from "./sendSecurityPhoto";
import fetchSecurityPhotos from "./fetchSecurityPhotos";
import fetchAssistance from "./fetchAssistance";
import sendAssistance from "./sendAssistance";
import sendEvidencePhoto from "./sendEvidencePhoto";
import finishExecution from "./finishExecution";
import updateCustomerVisibility from "./updateCustomerVisibility";
import rejectEvidencePhotos from "./rejectEvidencePhotos";
import rejectSecurityPhotos from "./rejectSecurityPhotos";
import updateEvidencePhotos from "./updateEvidencePhotos";
import updateSecurityPhotos from "./updateSecurityPhotos";
import returnToPT from "./returnToPT";
import rejectPanoramicPhotos from "./rejectPanoramicPhotos";
import markSinisterToRevision from "./markSinisterToRevision";
import setRealExecutedQuantity from "./setRealExecutedQuantity";

export default {
  fetchExpected,
  sendExpected,
  fetchReal,
  sendReal,
  fetchPhotoReasons,
  sendSecurityPhoto,
  fetchSecurityPhotos,
  fetchAssistance,
  sendAssistance,
  sendEvidencePhoto,
  finishExecution,
  updateCustomerVisibility,
  rejectSecurityPhotos,
  rejectEvidencePhotos,
  updateEvidencePhotos,
  updateSecurityPhotos,
  returnToPT,

  markSinisterToRevision,
  rejectPanoramicPhotos,
  setRealExecutedQuantity,
};



// WEBPACK FOOTER //
// ./src/services/workPlan/index.js